import React, { useEffect, useState } from 'react';
import { Box, ScrollView, View } from 'native-base';

import { Stashboard } from '@springbig/shared';
import MessageExtensionBox from "./MessageExtensionBox";

export const SliderLinkCard = ({ data }: { data: Stashboard }) => {

    const [extensions, setExtensions] = useState([]);
    const sortExtensions = () => {
        const _extensions = data && data.any_link_extensions && [...data.any_link_extensions, ...((data as any).extensions?.filter(extension => extension.type !== 'any_link') || [])]
        setExtensions(_extensions)
    };

    useEffect(() => {
        sortExtensions();
    }, []);


    return (
        <Box
            w={'100%'}
        >
            {extensions.length > 0 && (
                <View
                    mx={extensions.length === 1 ? 'auto' : ''}
                >
                    <ScrollView
                        my={6}
                        w={'100%'}
                        // @ts-ignore
                        horizontal={true}
                        decelerationRate={0}
                        showsHorizontalScrollIndicator={true}
                    >
                        {extensions.map((extension, i) => {

                            return (
                                <MessageExtensionBox
                                    type={extension.type || 'any_link'}
                                    walletType={extension.wallet_type}
                                    url={extension.url || ''}
                                    link={extension}
                                    key={`${i}-${extension.id}`}
                                    stashboardKey={data._key}
                                />
                            );
                        })}
                    </ScrollView>
                </View>
            )}
        </Box>
    );
};
